import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appointmentStatusPipe'
})
export class AppointmentStatusPipe implements PipeTransform {

  transform(value: string|null): string {
    switch(value) {
      case 'started': return 'Randevu';
      case 'canceled': return 'İptal';
      case 'finished': return 'Gerçekleşti';
      default:return "" // 23 Temmuz 18:50 Musa Aslan Belirsiz yazısını görmek istemediğini iletti 
    }
  }

}
